import {Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, TemplateRef, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-open-locataire-confirm',
    templateUrl: './open-locataire-confirm.component.html',
    styleUrls: ['./open-locataire-confirm.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OpenLocataireConfirmComponent {

  @Input() public title = 'Confirmation d\'ouverture';
  @Input() public message = 'Confirmez-vous l\'ouverture de ce contact à vos locataires ?';

  @Output() public deleted = new EventEmitter();
  @Output() public dismissed = new EventEmitter();
  @Output() public opened = new EventEmitter();

  @ViewChild('openLocataireConfirmationModal') openLocataireConfirmationModalTemplate: TemplateRef<any>;

  private modal: NgbModalRef;

  constructor(private modalService: NgbModal) { }

  confirm() {
    this.deleted.emit();
    this.closeModal();
  }

  dismiss() {
    this.dismissed.emit();
    this.closeModal();
  }

  @HostListener('click')
  openModal() {
    this.modal = this.modalService.open(this.openLocataireConfirmationModalTemplate);
    this.opened.emit();
  }

  closeModal() {
    this.modal.close();
  }
}
